export default defineNuxtPlugin((nuxtApp) => {
  // Only used on admin pages; keep vuedraggable/sortablejs out of the main bundle
  nuxtApp.vueApp.component('draggable', defineAsyncComponent(() => import('vuedraggable')))
})
